import styled from "styled-components";

export const WeatherContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  flex-grow: 0;

  p {
    font-size: 2.2rem;
    font-weight: 700;
    margin: 0;
    padding: 0;
    flex-shrink: 0;
    flex-grow: 0;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 0px;
    flex-shrink: 0;
    flex-grow: 0;

    p {
      font-size: 1rem;
      font-weight: 500;
      white-space: nowrap;
      flex-shrink: 0;
      flex-grow: 0;
      margin: 0;
      padding: 0;
      line-height: 1rem;
    }
  }

  &.half-width {
    gap: 2px;

    &.third {
      gap: 1px;
      p {
        font-size: 1.2rem;
      }
    }

    p {
      font-size: 1.3rem;
    }
  }

  @media screen and (max-height: 750px) {
    p {
      font-size: 1.6rem;
    }

    div {
      p {
        font-size: 0.7rem;
        line-height: 0.7rem;
      }
    }

    &.half-width {
      &.third {
        p {
          font-size: 0.9rem;
        }
      }

      p {
        font-size: 1.3rem;
      }
    }
  }
`;

export const WeatherIconContainer = styled.div`
  width: 20px;
  &.half-width {
    width: 13px;

    &.third {
      width: 12px;
    }
  }
`;
